<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center justify-content-between"> {{title_tab}}    
     
      <router-link to="/sertifikasi/data-waiver/tambah">
        <CButton color="success" style="float:right" class="btn-md">Tambah</CButton>
      </router-link>
    
    </CCardHeader>
    <!-- Tabs -->
    
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-waiver/penerima-waiver"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('Penerima Waiver')"
          aria-controls="home"
          aria-selected="true">Penerima Waiver</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-waiver/pengguna-waiver"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('Pengguna Waiver')"
          aria-controls="home"
          aria-selected="true">Pengguna Waiver</router-link>
      </li>      
    </ul>

    <!-- Data Waiver-->
    <router-view></router-view>
    <!-- End Data Waiver -->
  </CCard>
</template>
<script>

export default {
  name: "Master Waiver",
  data() {
    return {
        title_tab : 'Penerima Waiver',
    };
  },
  mounted() {
    this.mountedchange(this.$router.currentRoute.path)
  },
  watch: {
    
  },
  methods: {
      tabchange(value) {
          
          this.title_tab = value;
          switch (value) {
            case 'Penerima Waiver':
                // this.waiver_link_add = '/sertifikasi/data-waiver'
                break;
            case 'Pengguna Waiver':
                // this.waiver_link_add = '/sertifikasi/data-waiver/tambah'
                break;            
              default:
                break;
          }
      },
      mountedchange(value) {
        switch (value) {
            case '/sertifikasi/data-waiver':
                this.title_tab = 'Penerima Waiver';
                break;
            case '/sertifikasi/data-waiver/pengguna':
                this.title_tab = 'Pengguna Waiver';
                break;
            default:
                break;
        }
      }
  }
};
</script>